import initSearchTracking from "./events/search";
import initProductTracking from "./events/product";
import { initCartTracking } from "./events/cart";
import initCheckoutTracking from "./events/checkout";

function initializeGtmTracking() {
  initSearchTracking();
  initProductTracking();
  initCartTracking();
  initCheckoutTracking();
}

export default initializeGtmTracking;
